// custom-shipping-calculator.js - Clean Version

let shippingInProgress = false;
let recalcTimeout = null;
let addThrottle = false;


// --- Disable Checkout Button While Calculating Shipping ---
const CHECKOUT_SELECTORS = [
  // Checkout buttons
  '[name="checkout"]',
  '.cart__checkout',
  'button[type="submit"][form="cart"]',
  
  // PayPal parent containers (disable the whole container)
  '.additional-checkout-buttons',
  '[data-testid="paypal-smart-buttons"]',
  '.dynamic-checkout__content',
  '.shopify-payment-button'
].join(',');

function disableCheckoutButtons() {
  const elements = document.querySelectorAll(CHECKOUT_SELECTORS);
  
  elements.forEach(element => {
    element.style.opacity = '0.5';
    element.style.pointerEvents = 'none';
    
    // Add loading indicator
    const loadingText = document.createElement('div');
    loadingText.className = 'shipping-loading-overlay';
    
    element.style.position = 'relative';
    if (!element.querySelector('.shipping-loading-overlay')) {
      element.appendChild(loadingText);
    }
  });
}

function enableCheckoutButtons() {
  const elements = document.querySelectorAll(CHECKOUT_SELECTORS);
  
  elements.forEach(element => {
    element.style.opacity = '';
    element.style.pointerEvents = '';
    
    // Remove loading indicators
    const loadingOverlays = element.querySelectorAll('.shipping-loading-overlay');
    loadingOverlays.forEach(overlay => overlay.remove());
  });
}

// --- Banner Helpers ---
function showLoadingBanner() {
  const existingBanner = document.querySelector('[data-test-shipping-price]');
  if (existingBanner) existingBanner.remove();

  const banner = document.createElement('div');
  banner.style.cssText = `
    background: #2196F3;
    color: white;
    padding: 10px;
    text-align: center;
    margin: 10px 0;
    border-radius: 5px;
  `;
  banner.innerHTML = '⏳ Calculating shipping<br> You must wait for this to complete before checking out...';
  banner.setAttribute('data-test-shipping-price', 'true');

  const cartForm = document.querySelector('.cart__contents');
  if (cartForm) cartForm.insertBefore(banner, cartForm.firstChild);
}

function updatePriceDisplay(price) {
  const existingBanner = document.querySelector('[data-test-shipping-price]');
  if (existingBanner) existingBanner.remove();

  const banner = document.createElement('div');
  banner.style.cssText = `
    background: ${price == 0 ? '#4CAF50' : '#2196F3'};
    color: white;
    padding: 10px;
    text-align: center;
    margin: 10px 0;
    border-radius: 5px;
  `;
  banner.innerHTML = price == 0
    ? '🆓 Shipping Not Required'
    : `🚚 Calculated Shipping Price: $${parseFloat(price).toFixed(2)}`;
  banner.setAttribute('data-test-shipping-price', 'true');

  const cartForm = document.querySelector('.cart__contents');
  if (cartForm) cartForm.insertBefore(banner, cartForm.firstChild);
}

// --- Backend Shipping ---
async function calculateShippingFromBackend(cartItems) {
  try {
    const response = await fetch('https://endeavouraero.duckdns.org/calculate-shipping', {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({ items: cartItems, test: true })
    });

    if (!response.ok) throw new Error(`Backend returned ${response.status}`);
    const data = await response.json();

    if (!data.shipping_variant_id) {
      data.shipping_variant_id = 51994140770593;
    }

    return data;

  } catch (error) {
    console.error('Backend call failed:', error);
    return {
      success: false,
      shipping_cost: 0,
      shipping_variant_id: 51994140770593
    };
  }
}

// --- Remove existing shipping items ---
async function removeAllShippingItems(cart) {
  const shippingItems = cart.items.filter(item =>
    item.properties && item.properties._shipping_fee === 'true'
  );

  if (shippingItems.length === 0) return;

  const updates = {};
  shippingItems.forEach(item => updates[item.key] = 0);

  try {
    await fetch('/cart/update.js', {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({ updates })
    });
  } catch (error) {
    console.error('Error removing shipping items:', error);
  }
}

// --- Safe Add Shipping Item ---
async function safeAddShippingItem(variantId, cost) {
  if (addThrottle) return false;
  addThrottle = true;

  try {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({
        items: [{
          id: variantId,
          quantity: 1,
          properties: {
            '_shipping_fee': 'true',
            '_calculated_cost': cost.toString()
          }
        }]
      })
    }).then(r => r.json());

    if (res.status === 'too_many_requests') {
      return false;
    }

    return true;

  } catch (err) {
    console.error('Error adding shipping item:', err);
    return false;
  } finally {
    setTimeout(() => addThrottle = false, 400);
  }
}

// --- Main shipping calculation (debounced) ---
async function recalcShipping() {
  if (shippingInProgress) return;
  shippingInProgress = true;

  disableCheckoutButtons();
  showLoadingBanner();

  try {
    const cart = await fetch('/cart.js').then(r => r.json());
    await removeAllShippingItems(cart);

    const updatedCart = await fetch('/cart.js').then(r => r.json());

    const shippingData = await calculateShippingFromBackend(updatedCart.items);
    const cost = parseFloat(shippingData.shipping_cost) || 0;
    const variantId = shippingData.shipping_variant_id;

    if (cost === 0) {
      updatePriceDisplay(0);
      document.dispatchEvent(new Event('shipping:updated'));
      return;
    }

    const success = await safeAddShippingItem(variantId, cost);
    updatePriceDisplay(cost);

    if (success) document.dispatchEvent(new Event('shipping:updated'));

  } catch (err) {
    console.error('Error in shipping calculation:', err);
    document.dispatchEvent(new Event('shipping:updated'));
  } finally {
    shippingInProgress = false;
    enableCheckoutButtons();
  }
}

// --- Debounced attachment ---
function attachCartListeners() {
  document.addEventListener('cart:updated', () => {
    clearTimeout(recalcTimeout);
    recalcTimeout = setTimeout(recalcShipping, 400);
  });

  const cartContainer = document.querySelector('.cart__contents');
  if (!cartContainer) return;

  cartContainer.addEventListener('click', (e) => {
    if (e.target.closest('[data-index]') || e.target.closest('.cart__remove')) {
      clearTimeout(recalcTimeout);
      recalcTimeout = setTimeout(recalcShipping, 400);
    }
  });
}

// --- Initialize ---
function initShippingCalculator() {
  if (!document.querySelector('.cart__contents')) return;
  recalcShipping();
  attachCartListeners();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initShippingCalculator);
} else {
  initShippingCalculator();
}